export function title(str: string | null | undefined): string {
  if (!str) {
    return "";
  }
  return str
    .split(/(?=[A-Z])|[.\-\s_]/)
    .map((s) => s.trim())
    .filter((s) => Boolean(s))
    .map((s) => capitalize(s.toLowerCase()))
    .join(" ");
}

export function titleCase(str: string | null | undefined): string {
  if (!str) {
    return "";
  }
  return str.toLowerCase().split("_").map(capitalize).join(" ");
}

function capitalize(str: string): string {
  if (!str || str.length === 0) {
    return "";
  }
  const lower = str.toLowerCase();
  return lower.substring(0, 1).toUpperCase() + lower.substring(1, lower.length);
}

export function upperCaseWords(str: string) {
  return str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export const formatHeight = (feet?: number, inches?: number): string => {
  if (feet === undefined && inches === undefined) return "Not provided";
  return `${feet || 0} ft ${inches || 0} in`;
};

export const formatBodyRegion = (bodyRegion?: string): string => {
  if (!bodyRegion) return "Not provided";
  return bodyRegion
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};
